var youMayLove = new Swiper("[data-products-slider]", {
  slidesPerView: 1.5,
  spaceBetween: 20,
  navigation: {
    nextEl: "[data-products-slider-next]",
    prevEl: "[data-products-slider-prev]"
  },
  scrollbar: {
    el: "[data-products-slider-scrollbar]"
  },
  breakpoints: {
    768: {
      slidesPerView: 3.5
    },
    1200: {
      slidesPerView: 4.5
    }
  }
});